<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>PHỤ LỤC PHÍ THANH TOÁN THẺ</b>
      </p>
      <p class="txt-center">
        (PLUDP:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán số
            <mark>{{
              dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
            }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>
              {{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
            >
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="flex fonsize-16 txt-tranf">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>

        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
      </div>
      <p>và</p>
      <p class="flex fonsize-16 txt-tranf">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>

      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}
            <!-- {{ customerInfo.district }},
                {{ customerInfo.city }} -->
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Hai bên cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>
      <p>&nbsp;</p>
      <ol class="form-style1">
        <li>
          <h1>PHÍ THANH TOÁN THẺ</h1>
          <ol class="form-style2">
            <li>
              Khách hàng sử dụng thẻ Visa, Master, JCB do các Ngân hàng dưới đây phát hành để thanh
              toán tiền hàng hoá, dịch vụ bằng hình thức quẹt thẻ thanh toán trả ngay tại các Điểm
              chấp nhận thanh toán của Bên B sẽ được Bên A áp dụng thanh toán thẻ như sau:
            </li>
          </ol>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>Ngân hàng phát hành</b></th>
                  <th><b>Mức phí</b></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="txt-center"
                  v-for="(item, index) in dataAppendix.appendixOnUs.percentageFees"
                  :key="index"
                >
                  <td class="txt-center">{{ item.feeLabel ? item.feeLabel : item.bankName }}</td>
                  <td class="txt-center">{{ item.percentageFee }}</td>
                </tr>
              </tbody>
            </table>
            <div>
              <b>Lưu ý:</b>
              <ol class="form-style2">
                <li>
                  <i>
                    Mức phí thanh toán thẻ trên đã bao gồm VAT và chỉ được áp dụng khi Bên B cung
                    cấp đến Bên A đủ hồ sơ chứng từ theo yêu cầu của từng Ngân hàng và được Ngân
                    hàng phê duyệt. Mức phí này có thể thay đổi theo chính sách của Bên A và Ngân
                    hàng được ban hành tại từng thời điểm.
                  </i>
                </li>
                <li>
                  <i>
                    Trường hợp Bên B không đủ điều kiện Ngân hàng căn cứ trên hồ sơ, chứng từ không
                    phê duyệt áp dụng mức phí thanh toán thẻ này hoặc sau khi đã được áp dụng nhưng
                    Bên B vi phạm quy định của một trong các Ngân hàng áp dụng và Ngân hàng yêu cầu
                    khóa dịch vụ thì mức phí áp dụng là mức phí theo Phụ lục biểu phí và nguyên tắc
                    chấp nhận thanh toán đã ký giữa hai Bên và/ hoặc các công văn thông báo phí gần
                    nhất của Bên A đối với Ngân hàng đó.
                  </i>
                </li>
              </ol>
            </div>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ol class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong Phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ol>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'

  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixOnUss.find(e => e.isCreatedWithContract)
        )
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
